import { useEffect, useState } from "react";
import { getCssVariable } from 'src/utils/utils';
import Layout from '../Layout/Layout';
import { useLocation, useNavigate } from 'react-router-dom';
import { client } from 'src/utils/api';
import { SummitHero } from './components/SummitHero';
import { SummitImageAndText } from './components/SummitImageAndText';
import { SummitLocationList } from "./components/SummitLocationList";


const AdobeSummitDentsu = () => {
  const gqlClient = client;
  const primaryColor = getCssVariable("--primary-color");
  const navigate=useNavigate()
  const location = useLocation();
  const pathParts = location.pathname.toLowerCase().split("/").filter(Boolean);
  const isBaseRoute = pathParts.length === 1 && pathParts[0] === "summit-dentsu";
  const slug = isBaseRoute ? "summit-dentsu" : pathParts[1];
  const[summitData ,setSummitData]= useState<any[]>([])
  // Redefine state variable for specific components
  const [heroComponent, setHeroComponent] = useState<any>(null);
  const [imageTextComponent, setImageTextComponent] = useState<any>(null);
  const [locationComponent, setLocationComponent] = useState<any>(null);

  useEffect(() => {
    const featchSummitPage = async () => {
      try {
        const productResponse = await gqlClient.GetPageSummitBySlug({
          slug: slug,
        });

        const summitId =
          productResponse?.pageGenericCollection?.items[0]?.sys.id;

        if (!summitId) {
          navigate('/not-found', { replace: true });
          return;
        }
        const [responseOne] = await Promise.all([
          gqlClient.GetSummitPage({ id: summitId }),
        ]);

        
        const componentsOne =
          responseOne?.pageGeneric?.componentsCollection?.items || [];
       
        const cleanedData = [...componentsOne].filter(
          (item) => item && item.sys?.id && Object.keys(item).length > 2
        );

      
        setSummitData(cleanedData);
        
        // Find specific components from cleanedData with proper null checking
        const hero = cleanedData.find(item => item?.__typename === 'Hero') || null;
        const imageText = cleanedData.find(item => 
          item?.__typename === 'ImageAndText' && item?.variant === 'TextOnly'
        ) || null;
        const location = cleanedData.find(item => item?.__typename === 'ListOfLocation') || null;
        
        setHeroComponent(hero);
        setImageTextComponent(imageText);
        setLocationComponent(location);
      } catch (error) {
        console.error("Error fetching Product data:", error);
      }
    };

    featchSummitPage();
  }, [slug]);

const renderComponent = (component: any) => {
  if (!component) return null;
  
  const componentMap = {
    Hero: SummitHero,
    ImageAndText: {
      TextOnly: SummitImageAndText,
    },
    ListOfLocation: SummitLocationList,
  };

  const contentTypeId = component.__typename;
  const variant = component.variant;

  if (contentTypeId === "ImageAndText" && variant) {
    const Component = componentMap[contentTypeId]?.[variant];
    if (Component) {
      return <Component key={component.sys.id} content={component} />;
    }
    console.warn(
      `Unmapped variant: ${variant} for contentTypeId: ${contentTypeId}`
    );
    return null;
  } 
  
  const Component = componentMap[contentTypeId];
  if (Component) {
    return <Component key={component.sys.id} content={component} />;
  }
  
  console.warn(`Unmapped component type: ${contentTypeId}`);
  return null;
};

  useEffect(() => {
    const script = document.createElement('script');
    script.src='https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
        if ((window as any).hbspt) {
            (window as any).hbspt.forms.create({
                portalId: '45649448',
                formId: 'c1414505-f881-4b8e-9a43-6c4db2e34704',
                target: '#hubspotForm'
            })
        }
    });
}, []);



return (
  <Layout
    style={{
      color: primaryColor,
    }}
    hamburgerStyle={{
      backgroundColor: primaryColor,
    }}
    saleClassName={'btn-gradient-bdr'}
    headerStyle={{ position: 'relative' }}
  >
    <div className="content-left-img-component" style={{paddingBottom:"300px"}}>
      <div className="container-fluid custom-spacer-col">
        <div className="row align-items-start">
          {/* Left Column */}
          <div className="col-md-6 h-full flex flex-col justify-center mb-5 mb-md-0">
            {heroComponent && renderComponent(heroComponent)}
            
            <div className="summit-event">
              {imageTextComponent && renderComponent(imageTextComponent)}
              
              <div className="summit-event-content">
                {locationComponent && renderComponent(locationComponent)}
              </div>
            </div>
          </div>
          
          {/* Right Column */}
          <div className="col-md-6 flex summit-event-right">
            <div className="dentsu-event-right-img">

            {heroComponent?.heroImage?.url && (
                <img 
                  src={heroComponent.heroImage.url} 
                  alt={heroComponent.heroImage.alt || "Event Image"}
                  className="dentsu-event-image"
                />
              )}
            </div>
            <button className="btn-red-bdr" onClick={() => {
              window.open('https://www.eventbrite.com/e/gradial-dentsu-adobe-summit-dinner-tickets-1200387233529?aff=oddtdtcreator', '_blank');
            }}>
              {heroComponent?.primaryButton?.buttonText || 'Register Now'}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="9"
                viewBox="0 0 6 9"
                fill="none"
                className="btn-red-bdr-svg"
              >
                <path
                  d="M1 7.75L3.78571 4.5L1 1.25"
                  stroke="red"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                className="btn-red-bdr-svg-hover"
              >
                <path
                  d="M1 4.5h7"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M1 7.75L3.78571 4.5L1 1.25"
                  id="animated-path"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);
};

export default AdobeSummitDentsu;